import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Description.css";
import { TiTick } from "react-icons/ti";

export default function Description() {
  return (
    <Container className="description-details">
      <h2>Freedom to learn your way</h2>
      <p>
        Choose subscriptions or multiple course purchases. Discover and enroll
        in courses or programs directly from your LMS or native platform.
      </p>
      <Row>
        <Col lg={4}>
          <h5>
            <TiTick /> Choose subscriptions
          </h5>
          <p1>Get unlimited access to over 700 self-paced courses.</p1>
        </Col>
        <Col lg={4}>
          <h5>
            <TiTick /> Bulk purchase
          </h5>
          <p1>
            Choose access through individual-use enrollment codes or direct
            enrollment.
          </p1>
        </Col>
        <Col lg={4}>
          <h5>
            <TiTick /> LMS Integrations
          </h5>
          <p1>
            Integrate with Cornerstone, SAP SuccessFactors, Degreed, EdCast and
            others or directly with the edX API.
          </p1>
        </Col>
      </Row>
    </Container>
  );
}
